<button
    mat-icon-button
    (click)="click.emit()"
    [style.transform]="'scale(' + scale + ')'"
>
    <img
        [src]="imageUrl"
        [width]="imageSize"
        [height]="imageSize"
    >
</button>
